import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Planning/eliminarPlanning`, method: 'POST', body: values, token: token})
}